var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center fluid-base leading-relaxed font-light font-normal text-center h-screen p-4 w-full absolute top-0 left-0 pointer-events-none"},[_c('div',{staticClass:"w-56"},[_vm._v("\n    "+_vm._s(_vm.$t('cart.emptyCart'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }